import { Checkbox, Input, Typography } from "antd";
import { MxMerchantSettingModel } from "states/payment-gateway/payment-gateway.models";

export interface IMxmerchantSettingFormProps {
  model: MxMerchantSettingModel;
  onChange: (newModel: MxMerchantSettingModel) => void;
}

export function MxmerchantSettingForm(props: IMxmerchantSettingFormProps) {
  const { model, onChange } = props;
  return model ? (
    <>
      <Input.Group className="mb-4">
        <Typography.Text>Merchant Id: </Typography.Text>
        <Input
          value={model.merchantId}
          onChange={(e) => {
            onChange({ ...model, merchantId: e.target.value });
          }}
        />
      </Input.Group>
      <Input.Group className="mb-4">
        <Typography.Text>Consumer Key: </Typography.Text>
        <Input
          value={model.consumerKey}
          onChange={(e) => {
            onChange({ ...model, consumerKey: e.target.value });
          }}
        />
      </Input.Group>
      <Input.Group className="mb-4">
        <Typography.Text>Consumer Secret: </Typography.Text>
        <Input
          value={model.consumerSecret}
          onChange={(e) => {
            onChange({ ...model, consumerSecret: e.target.value });
          }}
        />
      </Input.Group>
      <Input.Group className="mb-4">
        <Checkbox
          checked={model.isSandbox}
          onChange={(e) => {
            onChange({ ...model, isSandbox: e.target.checked });
          }}
        >
          Is Sandbox
        </Checkbox>
      </Input.Group>
      <Input.Group>
        <Checkbox
          checked={model.isActive}
          onChange={(e) => {
            onChange({ ...model, isActive: e.target.checked });
          }}
        >
          Is Active
        </Checkbox>
      </Input.Group>
    </>
  ) : null;
}
